/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → GC content 50%, AT content 50%.`)
};

const es_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → contenido GC 50%, contenido AT 50%.`)
};

const de_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → GC-Gehalt 50%, AT-Gehalt 50%.`)
};

const nl_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → GC-gehalte 50%, AT-gehalte 50%.`)
};

const fr_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → contenu GC 50 %, contenu AT 50 %.`)
};

const it_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → contenuto GC 50%, contenuto AT 50%.`)
};

const pt_br2_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → conteúdo GC de 50%, conteúdo AT de 50%.`)
};

const pt_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → conteúdo GC de 50%, conteúdo AT de 50%.`)
};

const ja_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → GC含量50%、AT含量50%。`)
};

const zh_gc_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGC → GC 含量 50%，AT 含量 50%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_ex2", locale)
	if (locale === "en") return en_gc_ex2(inputs)
	if (locale === "es") return es_gc_ex2(inputs)
	if (locale === "de") return de_gc_ex2(inputs)
	if (locale === "nl") return nl_gc_ex2(inputs)
	if (locale === "fr") return fr_gc_ex2(inputs)
	if (locale === "it") return it_gc_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_gc_ex2(inputs)
	if (locale === "pt") return pt_gc_ex2(inputs)
	if (locale === "ja") return ja_gc_ex2(inputs)
	return zh_gc_ex2(inputs)
};